var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "-8 -8 40 40",
    enableBackground: "new -8 -8 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#FFC107",
    d: "M31.611,8.083H30V8H12v8h11.303c-1.648,4.656-6.08,8-11.303,8C5.373,24,0,18.627,0,12 S5.373,0,12,0c3.059,0,5.842,1.154,7.961,3.039l5.656-5.657C22.047-5.947,17.268-8,12-8C0.955-8-8,0.955-8,12s8.955,20,20,20 s20-8.955,20-20C32,10.659,31.863,9.35,31.611,8.083z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#FF3D00",
    d: "M-5.693,2.691L0.878,7.51C2.655,3.108,6.962,0,12.001,0c3.058,0,5.843,1.154,7.96,3.039 l5.656-5.657C22.047-5.947,17.27-8,12.001-8C4.318-8-2.344-3.663-5.693,2.691z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#4CAF50",
    d: "M12,32c5.166,0,9.859-1.977,13.41-5.191l-6.191-5.238C17.145,23.148,14.607,24.002,12,24 c-5.202,0-9.619-3.316-11.282-7.945l-6.522,5.023C-2.495,27.555,4.228,32,12,32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fill: "#1976D2",
    d: "M31.611,8.083H30V8H12v8h11.303c-0.787,2.217-2.209,4.152-4.088,5.57h0.004l6.191,5.236 C24.971,27.205,32,22,32,12C32,10.659,31.863,9.35,31.611,8.083z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.e12ab8fed272a2d1c80454f4c00bdf54.svg";
export { ForwardRef as ReactComponent };